import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Paylines } from "../GameComponents/Paylines";
import { ShapeElement } from "../Components/Elements/Graphics/ShapeElement";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { Attributes } from "../Utils/Attributes";
import { BaseElementAttributes } from "../Components/Elements/Graphics/BaseElement";

@engineComponent(ComponentTypes.DisplayObject)
export class PaylinesExtended extends Paylines {
    private _reelX: number[];
    private _reelY: number[];
    private _symbolWidth: number;
    private _symbolHeight: number;

    private _maskElement: ShapeElement;
    private _maskBackup: PIXI.Graphics | PIXI.Sprite;

    constructor() {
        super();
        this._maskElement = new ShapeElement({
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            color: 0xff0000,
            alpha: 0,
        });
        this.addChild(this._maskElement);

        // save mask
        this._maskBackup = this.mask;
    }

    configurate(node: Element) {
        super.configurate(node);

        if (node.getAttribute("ReelX")) {
            this._reelX = node
                .getAttribute("ReelX")
                .split(";")
                .map((v) => parseInt(v));
        }
        if (node.getAttribute("ReelY")) {
            this._reelY = node
                .getAttribute("ReelY")
                .split(";")
                .map((v) => parseInt(v));
        }
        if (node.getAttribute("SymbolWidth")) {
            this._symbolWidth = parseInt(node.getAttribute("SymbolWidth"));
        }
        if (node.getAttribute("SymbolHeight")) {
            this._symbolHeight = parseInt(node.getAttribute("SymbolHeight"));
        }
    }

    public updateByNode(node: Element): void {
        super.updateByNode(node);

        if (node.getAttribute("MaskEnabled")) {
            let value: boolean = Attributes.assignBooleanAttribute(node, "MaskEnabled", true);

            if (!this._maskBackup && this.mask) {
                this._maskBackup = this.mask;
            }

            if (value) {
                if (this._maskBackup && !this.mask) {
                    this.mask = this._maskBackup;
                }
            } else {
                this.mask = null;
            }
        }
    }

    public maskUpTo(count: number) {
        if (!this._reelX || !this._reelY || !this._symbolWidth || !this._symbolHeight) {
            if (DEBUG) {
                this.log("Missing PaylinesExtended mask attribute(s)!");
            }
            return;
        }
        this._maskElement.adjust({
            x: this._reelX[0] + this._symbolWidth * count,
            y: this._reelY[0],
            width: this._reelX[0] + (this._reelX.length - count) * this._symbolWidth,
            height: this._reelY[0] + this._reelY.length * this._symbolHeight,
        });
        this.mask = this._maskElement;
    }

    public unmask() {
        this.mask = null;
    }

    public goToCase(caseType: string, id?: number): void {
        if (id) {
            if (this._paylines[id - 1] != null) {
                this._paylines[id - 1].goToCase(caseType);

                let paylineNumber = this._paylines[id - 1].getChildElementByName("Number");
                if (paylineNumber != null) {
                    (<ImageTextElement>paylineNumber).setText(id.toString());
                }
            } else {
                if (DEBUG) {
                    this.log("ERROR no payline with id: " + (id - 1));
                }
            }
        } else {
            for (let i = 0; i < this._paylines.length; i++) {
                this._paylines[i].goToCase(caseType);

                let paylineNumber = this._paylines[i].getChildElementByName("Number");
                if (paylineNumber != null) {
                    (<ImageTextElement>paylineNumber).setText((i + 1).toString());
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PaylinesExtended.ts
 **/